import { render, staticRenderFns } from "./UnassignStudent.vue?vue&type=template&id=23a9c119&scoped=true"
import script from "./UnassignStudent.vue?vue&type=script&lang=js"
export * from "./UnassignStudent.vue?vue&type=script&lang=js"
import style0 from "./UnassignStudent.vue?vue&type=style&index=0&id=23a9c119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9c119",
  null
  
)

export default component.exports